import React from 'react'
import type { CallToActionBlock as CTABlockProps } from '@/payload-types'
import { CallToAction } from '@/components/CallToAction'

export const CallToActionBlock: React.FC<CTABlockProps> = ({ links, richText, media }) => {
  return (
    <CallToAction
      links={links || undefined}
      richText={richText}
      media={media}
    />
  )
}
